import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import Clients from './components/Clients';

const clients = (props,{ t }) => (
  <Container>
    <Clients {...props} />
  </Container>
);

clients.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation('common')(clients);
